/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './user-vaccination-schedule-details.reducer';

export const UserVaccinationScheduleDetailsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const userVaccinationScheduleDetailsEntity = useAppSelector(state => state.userVaccinationScheduleDetails.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userVaccinationScheduleDetailsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.detail.title">UserVaccinationScheduleDetails</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.id">Id</Translate>
            </span>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.active">Active</Translate>
            </span>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="dosage">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.dosage">Dosage</Translate>
            </span>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.dosage}</dd>
          <dt>
            <span id="givenDate">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.givenDate">Given Date</Translate>
            </span>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.givenDate}</dd>
          <dt>
            <span id="lastModifiedDt">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.lastModifiedDt">Last Modified Dt</Translate>
            </span>
          </dt>
          <dd>
            {userVaccinationScheduleDetailsEntity.lastModifiedDt ? (
              <TextFormat value={userVaccinationScheduleDetailsEntity.lastModifiedDt} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.microSec}</dd>
          <dt>
            <span id="periodInDays">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.periodInDays">Period In Days</Translate>
            </span>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.periodInDays}</dd>
          <dt>
            <span id="recDateMax">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.recDateMax">Rec Date Max</Translate>
            </span>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.recDateMax}</dd>
          <dt>
            <span id="recDateMin">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.recDateMin">Rec Date Min</Translate>
            </span>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.recDateMin}</dd>
          <dt>
            <span id="risk">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.risk">Risk</Translate>
            </span>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.risk}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.timestampentry}</dd>
          <dt>
            <span id="vaccinationTypeCd">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.vaccinationTypeCd">Vaccination Type Cd</Translate>
            </span>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.vaccinationTypeCd}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.lastupdated}</dd>
          <dt>
            <span id="completionStatus">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.completionStatus">Completion Status</Translate>
            </span>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.completionStatus}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.cursor}</dd>
          <dt>
            <span id="batchNumber">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.batchNumber">Batch Number</Translate>
            </span>
            <UncontrolledTooltip target="batchNumber">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.help.batchNumber" />
            </UncontrolledTooltip>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.batchNumber}</dd>
          <dt>
            <span id="serialNumber">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.serialNumber">Serial Number</Translate>
            </span>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.serialNumber}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.glucoUser ? userVaccinationScheduleDetailsEntity.glucoUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.vaccination">Vaccination</Translate>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.vaccination ? userVaccinationScheduleDetailsEntity.vaccination.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.scheduleDetails">Schedule Details</Translate>
          </dt>
          <dd>{userVaccinationScheduleDetailsEntity.scheduleDetails ? userVaccinationScheduleDetailsEntity.scheduleDetails.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/user-vaccination-schedule-details" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/user-vaccination-schedule-details/${userVaccinationScheduleDetailsEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserVaccinationScheduleDetailsDetail;
